const selectmultTable ={
  boxSelectedBefore:{
      border:'1px dashed #cdcdcd',padding:'20px',overflowY:'scroll',maxHeight:'450px',
      "& h4":{
          marginBottom:'20px',borderBottom:' 2px solid #562682'
      }
  },
  thQtd:{
      width:'30%'
  },
  thDesc:{
      width:'70%',paddingLeft:'20px'
  },
  detailDesc:{
      marginLeft:'20px',fontSize:'18px',marginBottom:'20px'
  }
};
  
export default selectmultTable;


